import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

import * as Styled from './FooterEmailSuccess.styled';

/**
 * Component that renders on successful email submission.
 */
const FooterEmailSuccess = ({ couponCode, discountPercentage }) => {
  const buttonRef = useRef(null);
  const couponRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    PubSub.publish('cart.discountApply', couponCode);
  }, []);

  const handleCopyCode = () => {
    couponRef.current.select();
    document.execCommand('copy');
    buttonRef.current.focus();

    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  };

  return (
    <Styled.FooterEmailSuccess>
      <Styled.HeadingSmall>
        <p>Get Excited. {discountPercentage}%&nbsp;Off Has</p>
        <p>Been Applied to Your Bag.</p>
      </Styled.HeadingSmall>
      <Styled.BodyCopySuccess>
        The code has been automatically applied to your bag.
      </Styled.BodyCopySuccess>
      <Styled.ButtonOutline
        type="button"
        size="large"
        variant="success"
        onClick={handleCopyCode}
        ref={buttonRef}
      >
        {isCopied ? (
          'Copied!'
        ) : (
          <Styled.ButtonTextWrap>
            <Styled.CheckIcon />
            <span>{couponCode}</span>
          </Styled.ButtonTextWrap>
        )}
      </Styled.ButtonOutline>
      <Styled.HiddenField
        value={couponCode}
        ref={couponRef}
        readOnly
        tabIndex="-1"
      />
    </Styled.FooterEmailSuccess>
  );
};

FooterEmailSuccess.propTypes = {
  /**
   * Coupon code to display to the user.
   */
  couponCode: PropTypes.string,
  /**
   * Percentage off value of the discount
   */
  discountPercentage: PropTypes.number
};

FooterEmailSuccess.defaultProps = {
  couponCode: 'COMFORT20',
  discountPercentage: 20
};

export default FooterEmailSuccess;
